import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { ARRIVAL_REPORT_ENDPOINT } from '../endpoint';
import { ArrivalReportRequestModel } from '../models/ArrivalReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: ArrivalReportRequestModel): Promise<void> => {
    return await axios
      .get(`${ARRIVAL_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'arrival-report',
        });
      });
  };
